import type { Transaction } from '@/types';

// A prepaid-card payment removed on the compliant register is counter-booked: it stays on the
// sale next to a counter-entry for the opposite amount (see components/register/CONTEXT.md).
// Neither can be edited anymore, so the register leaves both out. Rows without a partner are kept.
export const withoutCounterBookedPrepaidCardPayments = (
  transactions: Transaction[],
): Transaction[] => {
  const counterBookedIds: Transaction['id'][] = [];

  transactions.forEach((counterEntry) => {
    if (counterEntry.type !== 'PREPAID_CARD' || counterEntry.amount >= 0) {
      return;
    }

    const payment = transactions.find(
      (candidate) =>
        candidate.type === 'PREPAID_CARD' &&
        !counterBookedIds.includes(candidate.id) &&
        candidate.prepaidCard?.id === counterEntry.prepaidCard?.id &&
        candidate.amount === -counterEntry.amount,
    );

    if (payment) counterBookedIds.push(payment.id, counterEntry.id);
  });

  return transactions.filter(({ id }) => !counterBookedIds.includes(id));
};
